document.addEventListener('DOMContentLoaded', function() {
  const upsellsLarge = document.querySelector('.upsells.large-screen');
  if (!upsellsLarge) return;

  const upsellItems = upsellsLarge.querySelectorAll('.upsells-products .upsell-product_card');
  const btn = upsellsLarge.querySelector('#show-more-upsells-large');
  if (!btn) return;

  let expanded = false;

  function showInitial() {
    upsellItems.forEach((item, idx) => {
      if (idx < 10) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
    btn.textContent = 'Show More';
    expanded = false;
  }

  function showAll() {
    upsellItems.forEach(item => item.classList.remove('hidden'));
    btn.textContent = 'Show Less';
    expanded = true;
  }

  // Initial state
  if (upsellItems.length > 10) {
    showInitial();
    btn.style.display = 'block';
    btn.addEventListener('click', function() {
      if (expanded) {
        showInitial();
      } else {
        showAll();
      }
    });
  } else {
    btn.style.display = 'none';
  }
});
